import { render, staticRenderFns } from "./DevBody.vue?vue&type=template&id=905492a4"
import script from "./DevBody.vue?vue&type=script&lang=js"
export * from "./DevBody.vue?vue&type=script&lang=js"
import style0 from "./DevBody.vue?vue&type=style&index=0&id=905492a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports